import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Spinner} from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { sports } from '../../../../components/Util/enum';

export const TeamsTable = () => {
	const navigate = useNavigate();

	const [data_json, setDataJson] = useState(null);
	const [sportFilter, setSportFilter] = useState('');

	// Chip dello sport: le discipline delle squadre presenti nella lista.
	const sportOptions = useMemo(
		() => (data_json ? [...new Set(data_json.map((row) => row.sport).filter(Boolean))].sort() : []),
		[data_json],
	);

	const filteredData = useMemo(
		() => data_json && data_json.filter((row) => !sportFilter || row.sport === sportFilter),
		[data_json, sportFilter],
	);

	const [loadingShowed, setLoadingShowed] = useState(false);

	const data_column = [
		{
			Header : 'Team',
			Footer : 'Team',
			accessor: 'name',
			Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
				  {row.original.imageUrl && <img
					src={row.original.imageUrl}
					alt={row.original.name}
					style={{
					  width: '40px',
					  height: '40px',
					  borderRadius: '50%',
					  marginRight: '10px'
					}}
				  />}
				  {row.original.name}
				</div>
			)
		},
		{
			Header : 'Staff tecnico',
			accessor: 'coach',
		},
		{
			Header : 'Membri',
			Footer : 'Membri',
			accessor: 'members',
			disableGlobalFilter: true,
		},
		{
			Header : 'Sport',
			Footer : 'Sport',
			accessor: 'sport',
			disableGlobalFilter: true,
		},
	];

	function openDetail(row) {
		navigate('/struttura/teams/edit/'+row.id);
	}

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
					const clubId = tokenDetails.localId;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [teamsData] = await Promise.all([
                        apiClient.getTeams(token, clubId)
                    ]);
					setLoadingShowed(false);

					let data_teams = [];
					if(teamsData && teamsData.length > 0) {
						teamsData.forEach(element => {

							let image = null;
							if(element.logo) {
								image = element.logo;
							}

							let coach = null;
							if(element.captain && element.captain.fullName) {
								coach = element.captain.fullName;
							}

							let sport_decode = '';
							sports.forEach(element2 => {
								if(element2.value === element.sport) {
									sport_decode = element2.label;
								}
							});

							let teams_row = {
								"id": element.teamId,
								"name": element.name,
								"imageUrl": image,
								"coach": coach,
								"members": element.members?element.members.length:0,
								"sport": sport_decode
							};
							data_teams.push(teams_row);
						});
					}
					setDataJson(data_teams);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, []);
	
	return(
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<TabellaLista
				pageList={true}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				cardTitle={'Squadre'}
				hasSearch={true}
				searchPlaceholder={'Cerca per squadra o staff tecnico'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Sport" options={sportOptions} value={sportFilter} onChange={setSportFilter} asDropdown />
					</div>
				}
				hasAddMore={true}
				linkAddMore={'/struttura/teams/add'}
				labelAddMore={'Aggiungi'}
				data_column={data_column} 
				data_json={filteredData} 
            />
		</>
	)
	
}
export default TeamsTable;